import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { DataShareSettings } from '../schemas/data-share-settings.schema';

/**
 * Sets the company data share settings
 * @returns a data object indicating success
 */
export function postCompanyDataShareSettings(
  this: unknown,
  dataShareSettings: DataShareSettings
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(fleetEnvironment.resolve(this).companyDataShareSettingsUrl, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(dataShareSettings),
      })
    )
  ).pipe(
    selectData(
      z.object({
        data: z.boolean(),
      })
    )
  );
}
